// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { WaterMetersRoutingModule } from './water-meters-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { WaterMetersListComponent } from 'src/app/modules/water-meters/pages/water-meters-list/water-meters-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    WaterMetersRoutingModule,
    // PublicModule,
  ],
  declarations: [
    WaterMetersListComponent,
  ],
  entryComponents: [
  ],
  exports: [
  ]
})
export class WaterMetersModule { }
